import { Id, Request, RoleGroup } from 'src/types'

interface ShouldShowRDVButtonProps {
  request: Request
  roleGroup?: RoleGroup
  userId?: Id
}

function shouldShowRDVButton({ request }: ShouldShowRDVButtonProps) {
  const RDVstatus = [
    'CLOSING_PENDING',
    'CLOSING_REPROVED',
    'CONFERENCE_PENDING',
    'CONFERENCE_REPROVED',
    'FINISHED',
    'UNDERWAY'
  ]

  return request.request_user_data.every(user =>
    RDVstatus.includes(user.status)
  )
}

export { shouldShowRDVButton }
